/**
 * Mise en forme des sous-éléments repérés par NavigationSubItemIcon : retrait
 * sous l'icône de la rubrique, hauteur et police réduites, et trait vertical
 * qui les rattache visuellement à leur parent.
 */
const SUB_ITEM_CLASSES = [
  "has-[[data-navigation-sub-item]]:h-9",
  "has-[[data-navigation-sub-item]]:pl-11",
  "has-[[data-navigation-sub-item]]:text-[13px]",
  "has-[[data-navigation-sub-item]]:before:absolute",
  "has-[[data-navigation-sub-item]]:before:inset-y-0",
  "has-[[data-navigation-sub-item]]:before:left-[21px]",
  "has-[[data-navigation-sub-item]]:before:w-px",
  "has-[[data-navigation-sub-item]]:before:bg-current",
  "has-[[data-navigation-sub-item]]:before:opacity-20",
  "has-[[data-navigation-sub-item]]:before:content-['']",
].join(" ");

export const SIDEBAR_ITEM_CLASSES = SUB_ITEM_CLASSES;

export const NAVBAR_MENU_ITEM_CLASSES = `relative ${SUB_ITEM_CLASSES}`;
